import React, { useState } from "react";
// import { Button } from "antd";
// import { Player } from "video-react";
import { Modal } from "react-bootstrap";
import ReactPlayer from "react-player/lazy";
// import "video-react/dist/video-react.css";

const VideoPlayerModal = ({ d }) => {
  const [visible, setVisible] = useState(false);
  const [playing, setPlaying] = useState(false);

  const showModal = () => {
    setVisible(true);
    setPlaying(true);
  };

  console.log(d,"d d d")

  const hideModal = () => {
    setVisible(false);
    setPlaying(false);
  };

  return (
      <>
        <div
            onClick={showModal}
            className="col-lg-4 col-md-4 col-sm-6"
            role="button"
        >
          <div className="testimonials-item">
            <div className="testimonial-img">
              <ReactPlayer url={d.video == null ? d.url : d.video } alt="Video Player" className="img-fluid" />
              <div className="bg-overlay">
                <a href="#" className="play-icon" title="Play Video">
                  <i className="fa-solid fa-play"></i>
                </a>
              </div>
            </div>
            <div className="testimonial-content">
              <h6 dangerouslySetInnerHTML={{ __html: d.description }} />
            </div>
          </div>
        </div>
        <Modal
            show={visible}
            onHide={hideModal}
            centered
            size="lg"
            className="deal-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <span dangerouslySetInnerHTML={{ __html: d.description }} />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0 modal-body">
            <div
                style={{
                  // display: "flex",
                  // justifyContent: "center",
                  // alignItems: "center",
                  height: 500,
                   width: "100%"
                }}
                className="modal-body-bottom"
            >
              <ReactPlayer
                  playing={playing}
                  controls={true}
                  url={d.video == null ? d.url : d.video}
                  width={"100%"}
                  height={"100%"}
              />
            </div>
          </Modal.Body>
        </Modal>
      </>
  );
};

export default VideoPlayerModal;
